export default __webpack_public_path__ + "a844ef98f514d5e14beb6cb24ea66ce3.png";